import cookieHelper from "./getCookieData";

export const __user = (indexKey = false) => {
    if(indexKey === false) {
        return cookieHelper.getCookie("_vslaccdt")? true: false;
    }
    const obj = JSON.parse(cookieHelper.getCookie("_vslaccdt"))
    return obj[indexKey]
}